import { useEffect } from 'react'

import './_fans.scss'

import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import { usePageTitle } from 'context/pageTitleContext'
import DesktopAdditionalContent from 'features/DesktopAdditionalContent/DesktopAdditionalContent'
import { getFansGroups } from 'services/endpoints/fanGroup'

import { FansCustomGroup } from './components/FansCustomGroup'
import { FansHome } from './components/FansHome'

export interface FansGroup {
  id: string
  name: string
  slug: string
  count: number
  default: number
  primary?: number
  selected?: boolean
  created_at?: string
}

export const Fans = ({ displayPage }: { displayPage: string }) => {
  const { slug } = useParams<{ slug: string }>()

  const { t } = useTranslation()
  const { setTitle } = usePageTitle()

  const {
    data: groups = []
  } = useQuery<FansGroup[]>(
    ['fans-groups'],
    async () => await getFansGroups(),
    {
      staleTime: 30_000
    }
  )

  const currentGroup =
    slug != null
      ? groups.find(group => group.slug === slug) ?? null
      : null

  const renderPage = () => {
    switch (displayPage) {
      case 'home':
        return <FansHome />

      default:
        return (
          <FansCustomGroup
            group={currentGroup}
          />
        )
    }
  }

  useEffect(() => {
    setTitle(t('Fans'))
  }, [setTitle, t])

  return (
    <div className='fans-basic-layout'>
      {renderPage()}
      <DesktopAdditionalContent />
    </div>
  )
}